import { __rest } from "tslib";
import * as React from "react";
import { forwardRef } from "react";
import clsx from 'clsx';
const _AlertIcon = (_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement("svg", Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", role: "presentation", width: 16, height: 16, className: clsx("cmp-icon", className), ref: ref }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M9.436 4.341a3 3 0 0 1 5.13 0l.003.005 8.47 14.14.008.014a3 3 0 0 1-2.565 4.5H3.52a3 3 0 0 1-2.565-4.5l.008-.014L9.436 4.341Zm1.711 1.036L2.683 19.506A1 1 0 0 0 3.537 21h16.927a1 1 0 0 0 .854-1.494L12.856 5.379l-.002-.002a1 1 0 0 0-1.707 0Z", clipRule: "evenodd" }),
        React.createElement("path", { fillRule: "evenodd", d: "M12 9a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z", clipRule: "evenodd" }),
        React.createElement("path", { d: "M13 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }));
};
const AlertIcon = forwardRef(_AlertIcon);
export default AlertIcon;
//# sourceMappingURL=alert.js.map